export const GET_SALES_AGENT_LIST = 'GET_SALES_AGENT_LIST';
export const SET_SALES_AGENT_LIST = 'SET_SALES_AGENT_LIST';
export const CREATE_SALES_AGENT = 'CREATE_SALES_AGENT';
export const CREATE_SALES_AGENT_SUCCESS = 'CREATE_SALES_AGENT_SUCCESS';
export const CREATE_SALES_AGENT_FAILURE = 'CREATE_SALES_AGENT_FAILURE';
export const GET_SALES_AGENT_DETAILS = 'GET_SALES_AGENT_DETAILS';
export const SET_SALES_AGENT_DETAILS = 'SET_SALES_AGENT_DETAILS';
export const UPDATE_SALES_AGENT_STATUS = 'UPDATE_SALES_AGENT_STATUS';
export const UPDATE_SALES_AGENT_STATUS_SUCCESS = 'UPDATE_SALES_AGENT_STATUS_SUCCESS';
export const SET_STATUS_UPDATE_SUCCESS = 'SET_STATUS_UPDATE_SUCCESS';
export const UPDATE_SALES_AGENT = 'UPDATE_SALES_AGENT';
export const UPDATE_SALES_AGENT_SUCCESS = 'UPDATE_SALES_AGENT_SUCCESS';
export const UPDATE_SALES_AGENT_FAILURE = 'UPDATE_SALES_AGENT_FAILURE';
export const CLEAR_SALES_AGENT_ERROR = 'CLEAR_SALES_AGENT_ERROR';
export const GET_SALES_AGENT_MERCHANTS = 'GET_SALES_AGENT_MERCHANTS';
export const SET_SALES_AGENT_MERCHANTS = 'SET_SALES_AGENT_MERCHANTS';
export const CLEAR_SALES_AGENT_VIEW = 'CLEAR_SALES_AGENT_VIEW';
